import { z } from 'zod';
import type { ConfigOverride } from '#dn-types/host.ts';

/**
 * Our TagsForm needs to show allow list rules one row at a time, but the config overrides we
 * get from the api server has them all together in an object.
 *
 * This function splits that one override with an object into multiple config overrides each
 * containing only a single CIDR and allow rule, for rendering in the form.
 */
export function splitOverrides(overrides: ConfigOverride[]): ConfigOverride[] {
  const result: ConfigOverride[] = [];
  for (const override of overrides) {
    if (override.key === 'lighthouse.remote_allow_list') {
      const exploded = Object.entries(override.value);
      for (const [cidr, allow] of exploded) {
        result.push({ key: override.key, value: { [cidr]: allow } });
      }
    } else if (override.key === 'lighthouse.local_allow_list') {
      const { interfaces, ...cidrs } = override.value;
      const interfaceRules = Object.entries(interfaces);
      // parsing so that TypeScript is happy
      const cidrRules = Object.entries(z.record(z.boolean()).parse(cidrs));
      for (const [iface, allow] of interfaceRules) {
        result.push({ key: override.key, value: { interfaces: { [iface]: allow } } });
      }
      for (const [cidr, allow] of cidrRules) {
        result.push({ key: override.key, value: { interfaces: {}, [cidr]: allow } });
      }
    } else {
      result.push(override);
    }
  }
  return result;
}
